import { Navigate, Route, Routes } from 'react-router-dom';
import { useScrollTop } from '../../hooks/useScrollTop';
import { useSidebarState } from '../../hooks/useSidebarState';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import Conversations from '../../pages/Conversations';
import Dashboard from '../../pages/Dashboard';
import Leads from '../../pages/Leads';
import IntegrationsLayout from '../../pages/settings/integrations/Layout';
import SettingsLayout from '../../pages/settings/SettingsLayout';
import Statistics from '../../pages/Statistics';
import { DashboardHelper } from '../dashboard/DashboardHelper';
import DashboardSidebar from '../dashboard/DashboardSidebar';
import { MiniAppModal } from '../miniapps/MiniAppModal';
import AppNavbar from '../navigation/AppNavbar';
import { MobileMenu } from '../mobile/MobileMenu';

export default function AppLayout() {
  const { isExpanded } = useSidebarState();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  useScrollTop(); // Ajout du hook ici

  return (
    <div className="min-h-screen bg-main-gradient">
      <AppNavbar />
      
      {/* Affichage conditionnel du sidebar en fonction du device */}
      {!isMobile && <DashboardSidebar />}
      
      {/* Menu mobile dédié uniquement sur mobile */}
      {isMobile && <MobileMenu />}
      
      <div className={`pt-16 transition-all duration-300 ${
        isMobile ? 'pl-0' : (isExpanded ? 'pl-64' : 'pl-16')
      }`}>
        <Routes>
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="conversations" element={<Conversations />} />
          <Route path="visitors" element={<Leads />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="integrations/*" element={<IntegrationsLayout />} />
          <Route path="settings/*" element={<SettingsLayout />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </div>
      
      <DashboardHelper />
      <MiniAppModal />
    </div>
  );
}